import prospectGetPredicate from './prospect.getPredicate';
import prospectGetSimple from './prospect.getSimple';

export const getPredicate = prospectGetPredicate;
export const getSimple = prospectGetSimple;
